<div fxLayoutAlign="center center">
  <form #fsQstns="ngForm" (ngSubmit)="onSubmit(fsQstns.value)">
    <mat-card fxFlex>
      <mat-card-header fxLayoutAlign="space-between center" style="padding-bottom: 8px;">
        <mat-card-title fxLayoutGap="8px" role="heading" aria-level="1">
          Change Security Questions
        </mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="column"  fxLayoutGap="8px grid">
        <div>
          <mat-card appearance="outlined">
            <mat-card-header style="padding-top: 0px;">
            <mat-card-title fxLayoutGap="10px" role="heading" aria-level="1">Warning!</mat-card-title>
            <mat-card-subtitle role="heading" aria-level="2">
              Please select and answer three distinct questions from the selections below. This information will be used
              to validate your identity if you forget your password. Each question may only be used once.
              For additional assistance, select <a href="javascript:void(0)" (click)="$event.preventDefault();help();">Help</a> above.
            </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
        </div>
        <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" class=""
                        floatLabel="always">
          <mat-label>Security Question 1</mat-label>
          <mat-select #s1 fxFlex="auto" name="seqQue1Id" ngModel
                      (selectionChange)="onQuestionChange(s1?.value, 1)" required>
            <mat-option>Please Select Security Question.</mat-option>
            <mat-option *ngFor="let securityQuestion of securityQuestions" [value]="securityQuestion.security_q_id">
              {{securityQuestion.security_question}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" class=""
                        floatLabel="always">
          <input matInput type="text" name="answer1" ngModel required>
        </mat-form-field>
        <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline"
                        floatLabel="always">
          <mat-label>Security Question 2</mat-label>
          <mat-select #s2 fxFlex="auto" name="seqQue2Id" ngModel
                      (selectionChange)="onQuestionChange(s2?.value, 2)" required>
            <mat-option>Please Select Security Question.</mat-option>
            <mat-option *ngFor="let securityQuestion of securityQuestions" [value]="securityQuestion.security_q_id">
              {{securityQuestion.security_question}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline" class=""
                        floatLabel="always">
          <input matInput type="text" name="answer2" ngModel required>
        </mat-form-field>
        <mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%" appearance="outline"
                        floatLabel="always">
          <mat-label>Security Question 3</mat-label>
          <mat-select #s3 fxFlex="auto" name="seqQue3Id" ngModel
                      (selectionChange)="onQuestionChange(s3?.value, 3)" required>
            <mat-option>Please Select Security Question.</mat-option>
            <mat-option *ngFor="let securityQuestion of securityQuestions" [value]="securityQuestion.security_q_id">
              {{securityQuestion.security_question}}
            </mat-option>
          </mat-select>
        </mat-form-field><mat-form-field fxFlex="33%" fxFlex.lt-lg="50%" fxFlex.lt-md="100%"
                                         appearance="outline" class="" floatLabel="always">
        <input matInput type="text" name="answer3" ngModel required>
      </mat-form-field>
      </mat-card-content>
      <mat-card-actions fxLayoutAlign="center" fxLayoutGap="16px">
        <button color="primary" mat-raised-button type="submit"
                [disabled]="submitting || !fsQstns.dirty || fsQstns.invalid ">Update Info</button>
        <button color="warn" mat-raised-button type="button" (click)="fsQstns.reset()">Cancel</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
